import PROTECTED_ROUTES from "../constants/index";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import { useAuthContext } from "../hooks/useAuthContext";
import { useEffect, useState } from "react";

const ONBOARDING_ROUTES = ["/onboarding", "/onboarding/create-matcher"];
const CREATE_JOB_PATH = "/create-job";

const RoleRoutes = () => {
  const { user } = useAuthContext();
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState(false);

  const isOnboardingRoute = ONBOARDING_ROUTES.some((r) => location.pathname.startsWith(r));
  const isCreateJobPage = location.pathname.startsWith(CREATE_JOB_PATH);
  // Backend is source of truth: onboardingDone from GET user / login
  const onboardingDone = user?.onboardingDone === true || user?.newUser === false;
  const shouldRedirectToOnboarding = user && user.newUser && !user.onboardingDone && !isOnboardingRoute && !isCreateJobPage;
  const shouldRedirectAwayFromOnboarding = user && isOnboardingRoute && onboardingDone;

  useEffect(() => {
    const fullScreenRoutes =
      PROTECTED_ROUTES?.filter((r) => r.fullScreen)?.map((r) => r.link) ?? [];
    setShowSidebar(!fullScreenRoutes.includes(location.pathname));
  }, [location.pathname]);

  if (user && shouldRedirectAwayFromOnboarding) {
    return <Navigate to="/dashboard" replace />;
  }
  if (user && shouldRedirectToOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  const isWideContentPage = location.pathname === "/feedback" || location.pathname === "/profile";

  return user ? (
    <div className="flex min-h-screen bg-slate-50">
      {showSidebar && <Sidebar PROTECTED_ROUTES={PROTECTED_ROUTES} />}
      <main className="min-h-screen flex-1 pt-14 lg:pt-0">
        <div className={`page-content mx-auto w-full px-4 py-8 ${isWideContentPage ? "!max-w-5xl" : ""}`}>
          <Routes>
            {PROTECTED_ROUTES.map((route) => (
              <Route
                key={route.name}
                path={route.link}
                element={route.component}
              />
            ))}
          </Routes>
        </div>
      </main>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default RoleRoutes;
